import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch, useSelector } from 'react-redux'
import Template from './Template'

export const Root = ( props ) => {
  return <Template />
}

Root.propTypes = {
  foo: PropTypes.string
  // history: PropTypes.shape({
  //   action: PropTypes.string.isRequired
  // }).isRequired,
  // dispatch: PropTypes.func.isRequired
}

export default connect()( Root )
